export const meta = {
  slug: 'faq',
  title: 'Întrebări frecvente',
  description: 'Răspunsuri la cele mai frecvente întrebări despre platforma Programintrastat.ro.',
  icon: 'circle-question',
  order: 10,
  related: ['generare-intrastat', 'abonamente'],
};

export const images = {};

export const content = `
## Întrebări frecvente

În această secțiune puteți verifica dacă există răspunsuri în cazul în care aveți nelămuriri.

1. **Ce format de fișier Excel acceptă programul?**
   Programul acceptă format .xlsx și .xls

2. **Am achiziționat din greșeală un abonament nou iar cel vechi a fost dezactivat. Îl pot recupera?**
   Vă puteți recupera abonamentul vechi dacă cel nou este dezactivat iar cel anterior este încă valid. Pentru dezactivarea unui abonament trebuie să ne contactați la adresa de email [programintrastat@gmail.com](mailto:programintrastat@gmail.com) sau prin formularul de contact. Abonamentul nu poate fi anulat dacă a fost achitat.

3. **Am achitat un abonament nou, însă nu pot folosi încă programul?**
   În cazul în care ați efectuat plata unui abonament poate dura puțin până aceasta este procesată iar abonamentul va fi activ. Dacă totuși considerați că a trecut mai mult timp de la achitarea abonamentului, iar acesta nu este încă activ contactați-ne la adresa de email [programintrastat@gmail.com](mailto:programintrastat@gmail.com).

4. **Dacă încep un abonament demo și apoi doresc să trec la un abonament plătit se vor păstra toate datele mele?**
   Toate datele ce țin de contul dvs vor fi disponibile indiferent de abonamentul ales, indiferent că este demo sau cu plată.

5. **Nici unul din abonamentele disponibile nu îmi satisface nevoile. Pot avea un abonament la comandă?**
   Abonamentele la comandă se pot face contactându-ne la adresa de email [programintrastat@gmail.com](mailto:programintrastat@gmail.com).

6. **Aș dori să modific date precum CUI-ul firmei mele în cont. Pot face acest lucru?**
   Date precum CUI-ul și numărul la Reg Com al firmei nu pot fi modificate de către dvs. Pentru astfel de modificări vă rugăm să ne contactați.

7. **Vreau să-mi fac un cont, însă nu am voie să folosesc firma aleasă. De ce?**
   Este posibil ca un cont să existe deja cu acea firmă. În cazul acesta ne puteți contacta și vom putea remedia situația. În principiu nu este permis mai mult de un cont/firmă.

8. **Vreau să generez o declarație Intrastat însă nu doresc ca datele legate de furnizori/clienți să ajungă publice. Pot avea încredere în program?**
   Datele introduse din fișierele Excel pentru generarea declarației Intrastat nu sunt prelucrate pe server. Acestea sunt prelucrate local, ceea ce înseamnă că nimeni în afară de dvs nu are acces la datele acelea. Datele din fișierul excel și din declarația Intrastat generată nu sunt folosite nici măcar pentru statistici. Tot ce înseamnă date încărcate de către dvs și generate de către program sunt prelucrate pe calculatorul dvs.

9. **Am erori atunci când încarc fișierul XML generat în aplicația oficială INTRASTAT. Ce pot face?**
   - Ștergeți macheta pe care ați folosit-o la generare și să o refaceți de nouă cu fișierul Excel folosit ca referință.
   - Verificați că ați ales fișa de lucru corectă din fișierul Excel la crearea machetei, dar și la prelucrarea fișierului Excel.
   - Verificați dacă aveți cele mai noi nomenclatoare importate și activate în aplicația INTRASTAT oficială.
   - Încercați să eliminați coloane/rânduri goale din fișierul dvs Excel (dacă eliminați coloane va trebui să refaceți macheta).
   - Verificați dacă ați salvat ultimele modificări în fișierul Excel înainte de a-l importa.
   - În cazul în care aveți valori VAT în tabel, acestea va trebui verificate dând click pe butonul "Verificare VAT" înainte de generarea fișierului XML.
   - În cazul în care nicio metodă nu funcționează ne puteți contacta.

10. **Am generat fișierul XML. Ce fac cu acesta?**
    Fișierul rezultat din generarea programului va trebui încărcat în programul oficial INTRASTAT pe care îl puteți găsi online. Acesta va valida fișierul.
`;
